// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__26OAE","row":"Node_row__1kb-G","label":"Node_label__3GVgC","footer":"Node_footer__Wj8Sp"};